import {
  FETCH_CORTES_REQUEST,
  FETCH_CORTES_SUCCESS,
  FETCH_CORTES_FAILURE,
} from "../actions/cortes/types";

const initialState = { items: [], loading: false, error: null };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CORTES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_CORTES_SUCCESS:
      return { ...state, loading: false, items: Array.isArray(action.payload) ? action.payload : [], error: null };
    case FETCH_CORTES_FAILURE:
      return { ...state, loading: false, error: action.payload?.error ?? "Error desconocido" };
    default:
      return state;
  }
};

export default reducer;
